import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=0523a75b"
import script from "./PlusIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PlusIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports